function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.472,
    height: 10.115,
    viewBox: "0 0 14.472 10.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Tick Mark"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 497",
    d: "m1760.318 2785.193 3.942 3.787 7.7-7.7",
    transform: "translate(-1758.904 -2779.865)",
    style: {
      fill: "none",
      stroke: "#ffa539",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMark);
export default __webpack_public_path__ + "static/media/Tick Mark.170654f3bfc1085f85934b34a25cc390.svg";
export { ForwardRef as ReactComponent };